import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GuestService {
    BASE_URL = environment.api;
    path: string = '/guest/initialize';
    constructor(private http: HttpClient) {}

    setGuest(isGuest: boolean): void {
        sessionStorage.setItem('isGuest', JSON.stringify(isGuest));
    }

    getGuest(): boolean {
        return sessionStorage.getItem('isGuest') === 'true';
    }

    setGuestToken(token: string): void {
        sessionStorage.setItem('guestToken', token);
    }

    getGuestToken(): string | null {
        return sessionStorage.getItem('guestToken');
    }

    setGuestProjectId(projectId: string): void {
        sessionStorage.setItem('guestProjectId', projectId);
    }

    getGuestProjectId(): string | null {
        return sessionStorage.getItem('guestProjectId');
    }
    initializeGuestUser(): Observable<any> {
        console.log('checkinggg');
        const token = this.getGuestToken();
        if (!token) {
            throw new Error('Missing guest token');
        }

        return this.http.post(this.BASE_URL + this.path, { token });
    }
}
